// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1O5hV","choiceBoxes":"toolbarselects_choiceBoxes__2Q3Fo","simpleField":"toolbarselects_simpleField__29BJn"};